import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  disabledCell: {
    backgroundColor: `${theme.palette.disabled} !important`,
    borderColor: `${theme.palette.disabled} !important`,
    boxShadow: 'none !important',
    color: `${theme.palette.grey[400]} !important`,
    cursor: 'auto !important',
  },
}));

export default useStyles;
